import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

import { AppDispatch, store } from "./store"

export type RootState = ReturnType<typeof store.getState>
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
